import { api, provideApiHeaders } from '@/api';

/**
 * Admins see Lousa as anyone, coordinators as their students (started in Pessoas). Sent as the
 * X-View-As header: the API answers every request as that person, read-only. Kept per tab
 * (sessionStorage), so closing the tab or signing out goes back to the person's own account.
 */
const KEY = 'lousa.viewAs';

function storage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function stored(): string | null {
  try {
    return storage()?.getItem(KEY) ?? null;
  } catch {
    return null;
  }
}

provideApiHeaders((): Record<string, string> => {
  const id = stored();
  return id ? { 'X-View-As': id } : {};
});

export function viewingAs(): boolean {
  return stored() !== null;
}

/** Logs it (the audit trail) and reloads the app as that person. */
export async function startViewAs(personId: string) {
  await api.post<void>(`/users/${personId}/view-as`);
  try {
    storage()?.setItem(KEY, personId);
  } catch {
    return; // Without storage the header could not stick across the reload.
  }
  window.location.assign('/');
}

export function forgetViewAs() {
  try {
    storage()?.removeItem(KEY);
  } catch {
    // Nothing stored.
  }
}

/** Back to the person's own account (a full reload, so every page loads their data again). */
export function stopViewAs() {
  forgetViewAs();
  window.location.assign('/');
}
